export const YANDEX_FOOD_CATALOG_ID = '404';
export const YANDEX_WEBMASTER_CATALOG_ID = '594';
